import React from "react";
import _ from "lodash";
import { EuiToast } from "@elastic/eui";

export default function ({ title, body, isError, onCloseToast }) {
    return (
        <div className="euiGlobalToastList euiGlobalToastList--right">
            <EuiToast
                color={isError ? "danger" : "success"}
                iconType="alert"
                title={title}
                onClose={onCloseToast}
            >
                <p>{body}</p>
            </EuiToast>
        </div>
    );
}
